import 'posthog-js/dist/posthog-recorder'
import posthog from 'posthog-js/dist/module.full.no-external'

const posthogBrowser = posthog

export default posthogBrowser
